<template lang="pug">
  div(v-if="isPara && hasVtn").card-info
    el-row
      div.d-flex.tb
        .row
          .col
            p.verde-text.text-between {{mensagem}}
          .col
            el-button.green.textButtonBreak(
              tipo="success",
              v-if="hasVtn"
              @click="goLink()"
            )
              span.center
                i.fal.fa-credit-card
                | &nbsp {{mensagemBotao}}

</template>

<script>
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'

export default {

  props: {
    dadosVtn: {
      type: Object
    },
    showGestaoVtn: {
      default: true
    }
  },

  data () {
    return {
      daesBoleto: null,
      protocolo: null,
      informacoesVtn: null,
      processo: null,
      isVencido: true,
      isAmapa: process.env.ESTADO === 'ap',
      isPara: process.env.ESTADO === 'pa',
      isVisualizarVtn: '',
      hasVtn: false,
      isRoraima: process.env.ESTADO === 'rr',
      mensagem: 'Clique no botão para solicitar a antecipação ou quitação do seu VTN.',
      mensagemBotao: 'Solicitar antecipação/quitação do VTN',
      dadosProcesso: null
    }
  },
  mixins: [
    AppNotificacao
  ],
  async created () {
    this.protocolo = this.$route.params.idCadastro
  },

  async mounted () {
    if (!this.$route.fullPath.includes('/calculoPagamento') && this.showGestaoVtn) {
      let result = await this.getProcessoByProtocolo(this.$route.params.idCadastro)
      this.dadosProcesso = result
      this.processo = result
      this.informacoesVtn = await this.verificarVtn()
      if (this.informacoesVtn) {
        if (this.isPara) {
          this.isVisualizarVtn = true
          this.hasVtn = true
        }
      }
    }
  },
  methods: {
    ...mapActions({
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo'
    }),
    async reemite () {
      axios({
        method: 'POST',
        url: `financeiro/vtn/reemitirVTN/${this.protocolo}`
      }).then(async () => {
        this.informacoesVtn = await this.verificarVtn()
        this.$emit('reload')
      })
    },
    goLink () {
      this.$router.push({
        name: 'vtn/antecipacao-parcela-PA',
        params: {
          idVtn: this.informacoesVtn.id,
          processo: this.dadosProcesso
        }
      })
    },
    async verificarVtn () {
      try {
        let url = ''
        if (!this.isAmapa || !this.isRoraima) {
          if (this.protocolo) {
            url = `financeiro/vtn/verificaVTN/${this.protocolo}`
          }
        }
        if (this.isAmapa || this.isRoraima) {
          url = `analise/moduloVtn/vtn/processo/${this.processo.id}`
        }
        return await axios({
          method: 'GET',
          url: url
        })
      } catch (err) {
        console.error(err)
      }
    },
    verificarVtnFinalizada () {
      return this.isPara ? this.informacoesVtn && (this.informacoesVtn.aguardandoConfirmacaoInteressado || this.informacoesVtn.finalizado) : this.informacoesVtn !== null && this.informacoesVtn !== ''
    }
  }
}
</script>

<style scoped lang="scss">
.card-info {
  border-radius: 15px;
  background-color: #fff;
  border: solid 1px #009d64;
  margin: 2%;
  margin-bottom: -10px;
}

.d-flex {
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tb {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
}

.verde-text {
  color: #009d64 !important;
}

.green {
  color: #ffffff;
  background-color: #009f61;
  height: 40px;
}

.textButtonBreak {
  white-space: break-spaces;
}

.text-between {
 flex-direction: column;
}

.center {
  display: flex;
  align-items: center;
}

.botao{
  justify-content: flex-end;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  width: 100%;
  justify-content: space-between;
}

.col {
  display: flex;
  flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppAntecipacaoVtn.vue